/*
  Precarga de la segunda imagen de la ficha de producto (hover del grid).

  El problema: `.product-secondary-image` está en `display: none` hasta que el
  ratón entra (product-grid.css), y lazysizes descarta los elementos sin caja de
  layout — su comprobación de viewport exige que el getBoundingClientRect() no
  sea todo ceros. Resultado: la foto real no se pedía hasta el propio hover, y
  mientras llegaba se veía el placeholder de 20px (con blur, antes de quitarlo
  con la clase `no-blur`).

  Aquí la descargamos en cuanto el puntero entra en la ficha —no cuando llega a
  la imagen— y no dejamos que se muestre hasta que está lista: mientras tanto se
  sigue viendo la principal, sin parpadeo. El CSS que aplica esa espera está
  condicionado a la clase `se-hover-preload` del <html>, que ponemos aquí: si
  este script no llega a ejecutarse, el hover se comporta como siempre.
*/
(function () {
  'use strict';

  var READY_CLASS = 'se-img-ready';
  var FIGURE_READY_CLASS = 'se-hover-ready';
  var CARD_SELECTOR = '.product-card';
  var FIGURE_SELECTOR = '.product-featured-image';
  var IMAGE_SELECTOR = '.product-secondary-image';
  // Red de seguridad: si no llega ni 'load' ni 'error' (caché rara, imagen
  // servida desde bfcache, extensión que bloquea...) destapamos igualmente la
  // imagen para no dejar la ficha sin hover.
  var FALLBACK_MS = 5000;

  document.documentElement.classList.add('se-hover-preload');

  function markReady(image) {
    image.classList.add(READY_CLASS);

    // La figure se marca cuando ya están todas sus secundarias: es lo que
    // permite al CSS dejar de tapar la imagen principal, sin depender de :has().
    var figure = image.closest(FIGURE_SELECTOR);
    if (figure && !figure.querySelector(IMAGE_SELECTOR + ':not(.' + READY_CLASS + ')')) {
      figure.classList.add(FIGURE_READY_CLASS);
    }
  }

  function preloadImage(image) {
    if (image.dataset.seHoverPreload) {
      return;
    }
    image.dataset.seHoverPreload = '1';

    var pending = image.getAttribute('data-srcset');

    // Ya descargada (lazysizes la desveló por su cuenta, o venía sin lazyload).
    if (!pending && image.complete && image.naturalWidth > 0) {
      markReady(image);
      return;
    }

    image.addEventListener('load', function () { markReady(image); }, { once: true });
    image.addEventListener('error', function () { markReady(image); }, { once: true });
    setTimeout(function () { markReady(image); }, FALLBACK_MS);

    if (!pending) {
      return;
    }

    var lazySizes = window.lazySizes;

    if (lazySizes && lazySizes.loader && typeof lazySizes.loader.unveil === 'function') {
      // unveil() se salta el chequeo de viewport, que es justo lo que nos
      // bloqueaba, y deja que lazysizes siga gestionando sizes/srcset.
      lazySizes.loader.unveil(image);
      return;
    }

    // Sin lazysizes: montamos el srcset a mano. `data-sizes="auto"` no lo va a
    // resolver nadie, así que calculamos el ancho desde el contenedor.
    var box = image.closest('.product-featured-image-link') || image.parentNode;
    var width = box ? Math.round(box.getBoundingClientRect().width) : 0;

    if (width > 0) {
      image.setAttribute('sizes', width + 'px');
    }
    image.setAttribute('srcset', pending);
    image.removeAttribute('data-srcset');
    image.classList.remove('lazyload');
  }

  function preloadCard(card) {
    if (card.dataset.seHoverPreload) {
      return;
    }
    card.dataset.seHoverPreload = '1';

    var images = card.querySelectorAll(IMAGE_SELECTOR);
    for (var i = 0; i < images.length; i++) {
      preloadImage(images[i]);
    }
  }

  function onEnter(event) {
    var target = event.target;

    if (!target || typeof target.closest !== 'function') {
      return;
    }

    var card = target.closest(CARD_SELECTOR);
    if (card) {
      preloadCard(card);
    }
  }

  // Delegado en document para cubrir también las cards que se inyectan después
  // (quick view, recomendaciones del carrito, paginación infinita, filtros).
  document.addEventListener('pointerover', onEnter, { passive: true });
  document.addEventListener('touchstart', onEnter, { passive: true });
  document.addEventListener('focusin', onEnter, { passive: true });
})();
